import React from 'react';
import { List, Datagrid, Filter, ReferenceField, TextField, TextInput } from 'react-admin';

const DepartmentFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const DepartmentList = props => (
  <List filters={<DepartmentFilter />} {...props} exporter={false}>
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />

      <ReferenceField source="parentId" reference="companies" allowEmpty>
        <TextField source="name" />
      </ReferenceField>
        <ReferenceField source="homeroomTeacher" reference="employeeEnrollments" allowEmpty>
            <TextField source="customerName" />
        </ReferenceField>
    </Datagrid>
</List>
);

export default DepartmentList
